export class Node<T> {
  data: T;
  next: Node<T> | null;
  prev: Node<T> | null;

  constructor(data: T) {
    this.data = data;
    this.next = null;
    this.prev = null;
  }

  findRight(
    condition: (data: T) => boolean,
    startNode: Node<T> | null = null
  ): Node<T> | null {
    if (startNode === null)
      startNode = this;

    if (condition(this.data))
      return this;
    else if (this.next && this.next !== startNode)
      return this.next.findRight(condition, startNode);
    else return null;
  }

  findLeft(
    condition: (data: T) => boolean,
    startNode: Node<T> | null = null
  ): Node<T> | null {
    if (startNode === null)
      startNode = this;

    if (condition(this.data))
      return this;
    else if (this.prev && this.prev !== startNode)
      return this.prev.findLeft(condition, startNode);
    else return null;
  }
}

export class CircularLinkedList<T> {
  head: Node<T> | null;

  constructor() {
    this.head = null;
  }

  // Append a new node to the end of the list
  append(data: T) {
    const newNode = new Node<T>(data);

    if (this.head === null) {
      this.head = newNode;
      newNode.next = this.head;
      newNode.prev = this.head;
    } else if (this.head.prev) {
      const tail = this.head.prev;
      tail.next = newNode;
      newNode.prev = tail;
      newNode.next = this.head;
      this.head.prev = newNode;
    }
  }

  // Get the i'th node to the right of the head
  getNodeAt(index: number): Node<T> | null {
    if (this.head === null) return null;

    let current = this.head;
    let count = 0;

    do {
      if (count === index) return current;
      current = current.next!;
      count++;
    } while (current !== this.head);

    return null; // Return null if the index is out of bounds
  }

  // Print the list (for debugging)
  print() {
    if (this.head === null) return;

    let current = this.head;
    if (current.next === null) return;
    do {
      console.log(current.data);
      current = current.next;
    } while (current.next !== null && current !== this.head);
  }
}
